export enum productErrorTexts {
    TITLE = "Ой! Такой страницы на нашем сайте нет :(",
    DESCRIPTION = "Наверное, вы ошиблись при наборе адреса или перешли по неверной ссылке.",
    DESCRIPTION_ACTION = "Не расстраивайтесь, выход есть!",
    ACTION = "Перейдите на"
}
export const SCROLL_TRIGGER = 123;
export const ERROR_RECOMMENDED_TEXT = "Ошибка загрузки данных";
export const SHOW_ENTER_FORM_MESSAGE =
    'Зарегистрируйтесь и получите доступ к разделам "Избранное" и "Сравнение", что позволит удобно сравнивать и сохранять понравившиеся объявления';